import { useState, useRef, useEffect } from 'react';
export default function useMergedState(defaultStateValue, option) {
    const { defaultValue, value, onChange, postState } = option || {};
    const [innerValue, setInnerValue] = useState(() => {
        if (value !== undefined) {
            return value;
        }
        if (defaultValue !== undefined) {
            return defaultValue instanceof Function
                ? defaultValue()
                : defaultValue;
        }
        return defaultStateValue instanceof Function
            ? defaultStateValue()
            : defaultStateValue;
    });
    let mergedValue = value !== undefined ? value : innerValue;
    if (postState) {
        mergedValue = postState(mergedValue);
    }
    function triggerChange(newValue) {
        setInnerValue(newValue);
        if (mergedValue !== newValue && onChange) {
            onChange(newValue, mergedValue);
        }
    }
    // Effect of reset value to `undefined`
    const firstRenderRef = useRef(true);
    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        if (value === undefined) {
            setInnerValue(value);
        }
    }, [value]);
    return [mergedValue, triggerChange];
}
